import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import formdata from './formdata'

const state = {
   
    data: {
        name:'',        
        additional_name:'',
        web:'',
        email:'',
        phone:'',
        fax:'',
        mobile:'',
        adress_id:null,
        adress:null,
        companycategory_id:null,
        entity_ids:[]
        
    },

    companies:[],                
    
};

export default {
  namespaced: true,
  modules: {
        formdata: formdata,
        
    },
  state,
  actions,
  getters,
  mutations,
};